import { render, staticRenderFns } from "./calibrationTem.vue?vue&type=template&id=5d162a12&scoped=true"
import script from "./calibrationTem.vue?vue&type=script&lang=js"
export * from "./calibrationTem.vue?vue&type=script&lang=js"
import style0 from "./calibrationTem.vue?vue&type=style&index=0&id=5d162a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d162a12",
  null
  
)

export default component.exports